<template>
  <div>
    <a href="http://www.nih.gov/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/NIH.svg"
        alt="NIH"
        title="NIH"
        class="nih" />
      <img v-else src="./img/NIH-darkMode.svg" alt="NIH" title="NIH" class="nih" />
    </a>
    <a href="http://www.broadinstitute.org/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Broad.png"
        alt="Broad Institute"
        title="Broad Institute" />
      <img v-else src="./img/Broad-darkMode.png" alt="Broad Institute" title="Broad Institute" />
    </a>
    <a href="http://perkinelmer.com" rel="nofollow">
      <img src="./img/PerkinElmer.jpg" alt="PerkinElmer" title="PerkinElmer" />
    </a>
    <a href="http://www.autodesk.com/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Autodesk.png"
        alt="Autodesk"
        title="Autodesk"
        class="autodesk" />
      <img
        v-else
        src="./img/Autodesk-darkMode.png"
        alt="Autodesk"
        title="Autodesk"
        class="autodesk" />
    </a>
    <a href="http://www.nvidia.com" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" src="./img/nvidia.svg" alt="NVIDIA" title="NVIDIA" />
      <img v-else src="./img/NVIDIA-darkMode.svg" alt="NVIDIA" title="NVIDIA" />
    </a>
    <a
      href="http://www.csiro.au/en/Organisation-Structure/Divisions/Mathematics-Informatics-and-Statistics/Computational-simulation-sciences.aspx"
      rel="nofollow">
      <img src="./img/CSIRO.png" alt="CSIRO Computational Simulation Sciences" title="CSIRO" />
    </a>
    <a href="http://australianbioinformatics.net" rel="nofollow">
      <img src="./img/ABN.png" alt="Australian Bioinformatics Network" title="ABN" />
    </a>
  </div>
  <p>
    On Thursday afternoon, VIZBI 2013 was joined by members of the
    <a href="http://lincs.hms.harvard.edu/lincs-data-forum-2013/">LINCS Data Forum 2013</a> for a
    cross-over talk and poster session:
  </p>
  <div>
    <a href="http://lincs.hms.harvard.edu/lincs-data-forum-2013/" rel="nofollow">
      <img src="./img/LINCS.gif" alt="LINCS Data Forum 2013" title="LINCS Data Forum 2013" />
    </a>
  </div>
  <h4>Affiliations</h4>
  <div>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpg" alt="ISCB" title="ISCB" />
    </a>
  </div>
  <p>
    If you are interested in promoting your organization to VIZBI participants, download the
    <a href="/2013/VIZBI_SponsorshipForm2013.pdf" target="_blank">VIZBI sponsorship options</a>.
  </p>
</template>

<script setup>
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
img.nih {
  max-height: calc(3.3rem * 1.4);
}
img.autodesk {
  max-height: calc(3.3rem * 0.6);
}
</style>
